import React from 'react';
import TopNavbar from './TopNavbar';

function Header() {
  return <TopNavbar />;
}

export default Header;
